import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../../../../../../../store/reducers';
import { change } from 'redux-form';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldSelectList } from '../../../../../../../../../../components/redux-form/fields/FieldSelectList';
import GeneralEnumService from '../../../../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../../../../components/redux-form/utils/dropdown-values';
import user from '../../../../../../../../../../services/user-auth';
import UserRole from '../../../../../../../../../../enumerables/user-role';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        setIsManualChangeValue,
        isManualChangeValue,
        setTargetManualChangeValue,
        targetManualChangeValue,
        targetRow,
    } = props;

    if (fields.length == 0) {
        fields.push({});
    }
    return (
        <div className={classNames(styles.ul, styles.targetWrap)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    setTargetManualChangeValue={setTargetManualChangeValue}
                    targetManualChangeValue={targetManualChangeValue}
                    setIsManualChangeValue={setIsManualChangeValue}
                    isManualChangeValue={isManualChangeValue}
                    targetRow={targetRow}
                />
            ))}
        </div>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    targetRow: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    index,
    fields,
    isLast,
    isNotFirst,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    targetRow,
}) => {
    const row = fields.get(index);

    const seance = useSelector((state: StoreState) => state.seances.current);

    let [count, setCount] = useState(row.answer ? row.answer : 0);
    const dispatch = useDispatch();

    const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
    const isSupervisor = user.getSupervisor();
    const isJustProvider = isProvider && !isSupervisor;

    function incrementCount() {
        count = 100;
        setCount(count);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.answer`, count));
        }, 200);
        setIsManualChangeValue(true);
        setTargetManualChangeValue(targetRow?.id);
    }
    function decrementCount() {
        count = 0;
        setCount(count);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.answer`, count));
        }, 200);
        setIsManualChangeValue(true);
        setTargetManualChangeValue(targetRow?.id);
    }

    useEffect(() => {
        setCount(row.answer ? row.answer : 0);
    }, [row.answer]);

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const promptItems: SelectObject[] = getValFromEnum(EnumSet);
    const valPrompt = promptItems.find((it) => it.value === row?.prompt);
    const promptsTitles = valPrompt ? valPrompt.label : '';

    return (
        <div key={index} className={classNames(styles.wrappedFields, styles.wrappedFieldsOption)}>
            <FieldInput
                name={`${member}.id`}
                type="hidden"
                wrapperConfig={{
                    classes: {
                        inputWrapper: 'm-0',
                    },
                }}
            />
            <FieldInput
                name={`${member}.answer`}
                disabled={isJustProvider && seance?.status === 4}
                type="hidden"
                input={{ value: count }}
                wrapperConfig={{
                    // label: row?.title + ', %',
                    classes: { inputWrapper: 'm-0' },
                }}
            />

            <label className={classNames(styles.answerTitle)}>{row?.title}</label>
            {promptsTitles ? (
                <div className={classNames(styles.targetDescription)}>
                    <b>Prompt: </b>
                    <i>{promptsTitles}</i>
                </div>
            ) : (
                ''
            )}
            <div
                className={classNames(
                    styles.frequencyCounterBox,
                    seance?.status == 4 && isJustProvider ? styles.hideEdit : '',
                )}
            >
                <span
                    className={classNames(styles.frequencyMinus, styles.frequencyOptionButton)}
                    onClick={decrementCount}
                >
                    X
                </span>
                <div className={classNames(styles.frequencyValue)}>{count}</div>
                <span
                    className={classNames(styles.frequencyPlus, styles.frequencyOptionButton)}
                    onClick={incrementCount}
                >
                    <FontAwesomeIcon icon={faCheck} />
                </span>
            </div>

            {/*<div className={classNames(styles.targetSelectList, styles.optionSelectList, seance?.status == 4 ? styles.hideEdit : '')}>
                <FieldSelectList
                    name={`${member}.promptItem`}
                    data={row?.programTargetPrompts}
                    textField={'title'}
                    valueField={'prompt'}
                    onChange={(e) => {
                        setTimeout(() => {
                            dispatch(change('program-book', `${member}.promptItem`, e));
                        }, 200);
                    }}
                />
            </div>*/}
        </div>
    );
};
export default RenderFieldArray;
